module.exports = __webpack_public_path__ + "assets/img/B1.9664c60e.png";